import React from 'react';
import Hero from '../pages/hero'; // Import Hero component

const Home = () => {
  return (
    <div>
      <Hero />
    </div>
  );
};

export default Home;
